module.exports = __webpack_public_path__ + "static/media/personal_title.3a2c8ba1.svg";